import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es6.string.fixed.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import React from 'react';
import Column from './Column';
import ColumnGroup from './ColumnGroup';
import Icon from '../../wui-icon/src'; //行控制管理

var ColumnManager = /*#__PURE__*/function () {
  //缺省的列宽度
  function ColumnManager(_columns, elements, originWidth, _rowDraggAble, _showRowNum) {
    _classCallCheck(this, ColumnManager);

    _defineProperty(this, "_cached", {});

    _defineProperty(this, "addDragHandleColumn", function (columns, rowDraggAble) {
      if (!rowDraggAble) {
        return columns;
      }

      var dragHandleColumn = [{
        className: "drag-handle-column",
        title: "",
        key: "dragHandle",
        dataIndex: "dragHandle",
        width: 49,
        draggable: true,
        render: function render() {
          return /*#__PURE__*/React.createElement(Icon, {
            type: "uf-navmenu"
          });
        }
      }];
      columns = dragHandleColumn.concat(columns);
      return columns;
    });

    _defineProperty(this, "deleteColumnNotShow", function (columns) {
      var len = columns.length;

      for (var i = 0; i < len; i++) {
        if (columns && columns[i] && columns[i].isShow === false) {
          columns.splice(i, 1);
          i--;
        }
      }

      return columns;
    });

    _defineProperty(this, "addOrderColumn", function (columns, showRowNum) {
      if (!showRowNum) {
        return columns;
      }

      var key = showRowNum.key,
          fixed = showRowNum.fixed,
          width = showRowNum.width,
          name = showRowNum.name,
          type = showRowNum.type,
          base = showRowNum.base;
      var order = {
        dataIndex: key || '_index',
        key: '_index',
        fixed: fixed || 'left',
        width: width || 50,
        title: name || '序号',
        render: function render(text, record, index) {
          switch (type) {
            case 'ascii':
              {
                return String.fromCharCode((base || 'a').charCodeAt() + index);
              }

            case 'number':
            default:
              {
                return (base || 0) + index;
              }
          }
        }
      };

      if (columns.length > 0 && columns[0].dataIndex !== 'checkbox' && columns[0].dataIndex !== 'radio') {
        // 多选表格/单选表格时放在第二列,其他情况放到第一列
        columns = [order].concat(columns);
      } else {
        columns.splice(1, 0, order); // splice方法改变原数组,返回切割出的数组,此处为[]
      }

      return columns;
    });

    _columns = this.addDragHandleColumn(_columns, _rowDraggAble);
    _columns = this.addOrderColumn(_columns, _showRowNum);
    _columns = this.deleteColumnNotShow(_columns);
    this.columns = _columns || this.normalize(elements);
    this.originWidth = originWidth;
  } // 向数据列中添加一列:行拖拽标识


  _createClass(ColumnManager, [{
    key: "isAnyColumnsFixed",
    value: function isAnyColumnsFixed() {
      var _this = this;

      return this._cache('isAnyColumnsFixed', function () {
        return _this.columns.some(function (column) {
          return !!column.fixed;
        });
      });
    }
  }, {
    key: "isAnyColumnsLeftFixed",
    value: function isAnyColumnsLeftFixed() {
      var _this2 = this;

      return this._cache('isAnyColumnsLeftFixed', function () {
        return _this2.columns.some(function (column) {
          return column.fixed === 'left' || column.fixed === true;
        });
      });
    }
  }, {
    key: "isAnyColumnsRightFixed",
    value: function isAnyColumnsRightFixed() {
      var _this3 = this;

      return this._cache('isAnyColumnsRightFixed', function () {
        return _this3.columns.some(function (column) {
          return column.fixed === 'right';
        });
      });
    }
  }, {
    key: "leftColumns",
    value: function leftColumns() {
      var _this4 = this;

      return this._cache('leftColumns', function () {
        return _this4.groupedColumns().filter(function (column) {
          return column.fixed === 'left' || column.fixed === true;
        });
      });
    }
  }, {
    key: "rightColumns",
    value: function rightColumns() {
      var _this5 = this;

      return this._cache('rightColumns', function () {
        return _this5.groupedColumns().filter(function (column) {
          return column.fixed === 'right';
        });
      });
    }
  }, {
    key: "centerColumns",
    value: function centerColumns() {
      var _this6 = this;

      return this._cache('centerColumns', function () {
        return _this6.groupedColumns().filter(function (column) {
          return !column.fixed;
        });
      });
    } //全部末级列（多表头下）节点

  }, {
    key: "leafColumns",
    value: function leafColumns() {
      var _this7 = this;

      return this._cache('leafColumns', function () {
        return _this7._leafColumns(_this7.columns);
      });
    }
  }, {
    key: "leftLeafColumns",
    value: function leftLeafColumns() {
      var _this8 = this;

      return this._cache('leftLeafColumns', function () {
        return _this8._leafColumns(_this8.leftColumns());
      });
    }
  }, {
    key: "rightLeafColumns",
    value: function rightLeafColumns() {
      var _this9 = this;

      return this._cache('rightLeafColumns', function () {
        return _this9._leafColumns(_this9.rightColumns());
      });
    }
  }, {
    key: "centerLeafColumns",
    value: function centerLeafColumns() {
      var _this10 = this;

      return this._cache('centerLeafColumns', function () {
        return _this10._leafColumns(_this10.centerColumns());
      });
    } //获取显示的列

  }, {
    key: "showLeafColumns",
    value: function showLeafColumns(fixed) {
      var columns = [];

      if (fixed) {
        if (fixed == 'right') {
          columns = this.rightLeafColumns();
        } else {
          columns = this.leftLeafColumns();
        }
      } else {
        columns = this.centerLeafColumns();
      }

      var showColumns = columns.filter(function (col) {
        return col.ifshow == true;
      });
      return showColumns;
    } // add appropriate rowspan and colspan to column

  }, {
    key: "groupedColumns",
    value: function groupedColumns(type) {
      var _this11 = this;

      return this._cache('groupedColumns', function () {
        var _groupColumns = function _groupColumns(columns) {
          var currentRow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          var parentColumn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var rows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
          // track how many rows we got
          rows[currentRow] = rows[currentRow] || [];
          var grouped = [];

          var setRowSpan = function setRowSpan(column) {
            var rowSpan = rows.length - currentRow;

            if (column && !column.children && // parent columns are supposed to be one row
            rowSpan > 1 && (!column.rowSpan || column.rowSpan < rowSpan)) {
              column.rowSpan = rowSpan;
            }
          };

          columns.forEach(function (column, index) {
            var defaultOpt = {
              ifshow: true
            };

            if (!_this11.originWidth) {
              defaultOpt.width = ColumnManager.DefaultColumnWidth;
            } //获取非固定列


            if (type == 'nofixed' && column.fixed) {
              return false;
            }

            var newColumn = _objectSpread(_objectSpread({}, defaultOpt), column);

            rows[currentRow].push(newColumn);
            parentColumn.colSpan = parentColumn.colSpan || 0;

            if (newColumn.children && newColumn.children.length > 0) {
              newColumn.children = _groupColumns(newColumn.children, currentRow + 1, newColumn, rows);
              parentColumn.colSpan = parentColumn.colSpan + newColumn.colSpan;
            } else {
              parentColumn.colSpan++;
            } // update rowspan to all same row columns


            for (var i = 0; i < rows[currentRow].length - 1; ++i) {
              setRowSpan(rows[currentRow][i]);
            } // last column, update rowspan immediately


            if (index + 1 === columns.length) {
              setRowSpan(newColumn);
            }

            grouped.push(newColumn);
          });
          return grouped;
        };

        return _groupColumns(_this11.columns);
      });
    }
  }, {
    key: "normalize",
    value: function normalize(elements) {
      var _this12 = this;

      var columns = [];
      React.Children.forEach(elements, function (element) {
        if (!_this12.isColumnElement(element)) return;

        var column = _objectSpread({}, element.props);

        if (element.key) {
          column.key = element.key;
        }

        if (element.type === ColumnGroup) {
          column.children = _this12.normalize(column.children);
        }

        columns.push(column);
      });
      return columns;
    }
  }, {
    key: "isColumnElement",
    value: function isColumnElement(element) {
      return element && (element.type === Column || element.type === ColumnGroup);
    }
  }, {
    key: "reset",
    value: function reset(columns, elements, showRowNum, rowDraggAble) {
      columns = this.addDragHandleColumn(columns, rowDraggAble);
      columns = this.addOrderColumn(columns, showRowNum);
      columns = this.deleteColumnNotShow(columns);
      this.columns = columns || this.normalize(elements);
      this._cached = {};
    }
  }, {
    key: "clearCache",
    value: function clearCache() {
      this._cached = {};
    }
  }, {
    key: "getColumnWidth",
    value: function getColumnWidth(contentWidth) {
      var columns = this.leafColumns();
      var res = {
        computeWidth: 0,
        lastShowIndex: -1
      };
      var centerShowColCount = 0; //中间区域的可见列个数

      columns.forEach(function (col, index) {
        //如果列显示
        if (col.ifshow) {
          var width = col.width;

          if (typeof width == 'string' && width.includes('%')) {
            width = contentWidth * parseInt(col.width) / 100;
          }

          res.computeWidth += parseInt(width);

          if (!col.fixed) {
            centerShowColCount++;
          }
        }
      });
      res.lastShowIndex = centerShowColCount - 1;
      return res;
    }
  }, {
    key: "getLeftColumnsWidth",
    value: function getLeftColumnsWidth() {
      var _this13 = this;

      var contentWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      return this._cache('leftColumnsWidth', function () {
        var leftColumnsWidth = 0;

        _this13.groupedColumns().forEach(function (column) {
          if (column.fixed === 'left' || column.fixed === true) {
            var width = column.width;

            if (typeof width == 'string' && width.includes('%')) {
              width = contentWidth * parseInt(column.width) / 100;
            }

            leftColumnsWidth += parseInt(width);
          }
        });

        return leftColumnsWidth;
      });
    }
  }, {
    key: "getRightColumnsWidth",
    value: function getRightColumnsWidth() {
      var _this14 = this;

      var contentWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      return this._cache('rightColumnsWidth', function () {
        var rightColumnsWidth = 0;

        _this14.groupedColumns().forEach(function (column) {
          if (column.fixed === 'right') {
            var width = column.width;

            if (typeof width == 'string' && width.includes('%')) {
              width = contentWidth * parseInt(column.width) / 100;
            }

            rightColumnsWidth += parseInt(width);
          }
        });

        return rightColumnsWidth;
      });
    } //通过key或dataIndex查找匹配的列定义（支持多表头的列定义情况）

  }, {
    key: "findColumn",
    value: function findColumn(columnKey) {
      return this._findColumn(columnKey, this.columns || []);
    }
  }, {
    key: "_findColumn",
    value: function _findColumn(columnKey, columns) {
      for (var i = 0; i < columns.length; i++) {
        var findOne = null;
        var column = columns[i];
        if (!column) continue;

        if (column.key == columnKey || column.dataIndex == columnKey) {
          //兼容只有key的情况
          findOne = column;
        } else {
          if (column.children) {
            findOne = this._findColumn(columnKey, column.children);
          }
        }

        if (findOne) return findOne;
      }
    }
  }, {
    key: "_cache",
    value: function _cache(name, fn) {
      if (name in this._cached) {
        return this._cached[name];
      }

      this._cached[name] = fn();
      return this._cached[name];
    } //todo 含有children的宽度计算

  }, {
    key: "_leafColumns",
    value: function _leafColumns(columns) {
      var _this15 = this;

      var leafColumns = [];
      columns.forEach(function (column) {
        if (!column.children) {
          var defaultOpt = {
            ifshow: true
          };

          if (!_this15.originWidth) {
            defaultOpt.width = ColumnManager.DefaultColumnWidth;
          }

          var newColumn = _objectSpread(_objectSpread({}, defaultOpt), column);

          leafColumns.push(newColumn);
        } else {
          leafColumns.push.apply(leafColumns, _toConsumableArray(_this15._leafColumns(column.children)));
        }
      });
      return leafColumns;
    }
  }]);

  return ColumnManager;
}();

_defineProperty(ColumnManager, "DefaultColumnWidth", 200);

export { ColumnManager as default };


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-table/src/ColumnManager.js